/**
 * List Schema of TipoPessoaRecebedor
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {TipoPessoaRecebedor} from '@/model/resource/TipoPessoaRecebedor'

/* TODO: review generated schema */
export class ListTipoPessoaRecebedorSchema extends Schema {
  readonly name = 'ListTipoPessoaRecebedor'

  readonly fieldSet: FieldSet<TipoPessoaRecebedor> = {
    idTipoPessoaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
